import { IStoredTranscription, TranscriptionStorageType } from './interfaces/IStoredTranscription'
import { DocumentStorageTranscriptionManager } from './DocumentStorageTranscriptionManager'
import { ITranscriptionManager } from './interfaces/ITranscriptionManager'

export function CreateTranscriptionManager(storedTranscription: IStoredTranscription): ITranscriptionManager {
    switch (storedTranscription.storageType) {
        case TranscriptionStorageType.DocumentStorage:
            return new DocumentStorageTranscriptionManager(storedTranscription.descriptor);
        default:
            throw new Error('Unsupported transcription storage type: ' + storedTranscription.storageType);
    }
}